import { usePageHasUserGuide } from './use-page-has-user-guide'
import { useUserDismissed } from './use-user-dismissed'

export const useShouldShowGettingStarted = (skipCompleted = false) => {
  const [userDismissed] = useUserDismissed(skipCompleted)
  const pageHasUserGuide = usePageHasUserGuide()

  if (userDismissed || !pageHasUserGuide) return false

  return true
}
